import CourtyardLeftSideBarNav from "./CourtyardLeftSideBarNav";

const CourtyardMenuLayout = ({ children }) => {
    return (
        <div>
            <CourtyardLeftSideBarNav />
            {children}
        </div>
    )
}

export default CourtyardMenuLayout;